module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "c-header js-header u-fixed u-pos-tl u-zindex--5 u-flex u-flex-jc--center u-flex-ai--center u-fit-vw",
    class: [_vm.$root.smoothScroll > _vm.$root.height / 100 * 5 ? 'has-scrolled' : '']
  }, [_c('div', {
    staticClass: "c-header__background u-absolute u-pos-tl u-fit u-bg--white"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-header__wrapper u-flex u-flex-jc--space-between u-flex-ai--end u-w8of10",
    class: [_vm.$root.width <= _vm.$root.CONSTANTS.breakpoints.sm || _vm.$root.isTouch ? 'has-menu-burger' : '']
  }, [_c('div', {
    staticClass: "c-header__logotypes u-relative u-flex u-flex-jc--space-between"
  }, [_c('router-link', {
    staticClass: "u-relative u-flex u-flex-jc--space-between u-click-area-xxs t-link",
    attrs: {
      "to": _vm.$root.getPageURLFromName('home')
    }
  }, [_c('div', {
    staticClass: "c-header__logotypes__four-seasons u-relative u-flex u-flex-ai--end"
  }, [_c('img', {
    staticClass: "c-header__logotypes__four-seasons__image",
    attrs: {
      "src": _vm.content.logotype_left.url,
      "alt": "Four Seasons - Logotype",
      "title": "Four Seasons - Logotype"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-header__logotypes__separator u-marg-x-sm u-bg--gray-light u-opacity--50"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-header__logotypes__edmond-rothschild u-relative u-flex u-flex-ai--end"
  }, [_c('img', {
    staticClass: "c-header__logotypes__edmond-rothschild__image",
    attrs: {
      "src": _vm.content.logotype_right.url,
      "alt": "Edmond Rothschild - Logotype",
      "title": "Edmond Rothschild - Logotype"
    }
  })])])], 1), _vm._v(" "), (_vm.$root.width > _vm.$root.CONSTANTS.breakpoints.sm && !_vm.$root.isTouch) ? _c('nav', {
    staticClass: "u-flex"
  }, [_c('div', {
    staticClass: "c-header__link"
  }, [_c('router-link', {
    staticClass: "u-relative t-link u-click-area-xxs",
    attrs: {
      "to": _vm.$root.getPageURLFromName('contact')
    }
  }, [_c('span', {
    staticClass: "t-text--xxs u-color--black-near u-uppercase t-ffamily--domaine t-fweight--bold",
    domProps: {
      "innerHTML": _vm._s(_vm.content.label_link_contact)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "c-header__link u-marg-l-md"
  }, [_c('router-link', {
    staticClass: "u-relative t-link u-click-area-xxs",
    attrs: {
      "to": _vm.$root.getPageURLFromName('chef')
    }
  }, [_c('span', {
    staticClass: "t-text--xxs u-color--black-near u-uppercase t-ffamily--domaine t-fweight--bold",
    domProps: {
      "innerHTML": _vm._s(_vm.content.label_link_chef)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "c-header__restaurants c-header__link u-relative u-marg-l-md u-flex u-flex-ai--center u-click-area-xxs u-cursor-pointer",
    class: [_vm.menuIsOpen ? 'is-open' : 'is-close'],
    on: {
      "click": function($event) {
        _vm._clickOnRestaurants()
      }
    }
  }, [_c('span', {
    staticClass: "t-text--xxs u-color--brand-gold u-uppercase t-ffamily--domaine t-fweight--bold",
    domProps: {
      "innerHTML": _vm._s(_vm.content.label_link_restaurants)
    }
  }), _vm._v(" "), _vm._m(0)])]) : (_vm.$root.width <= _vm.$root.CONSTANTS.breakpoints.sm || _vm.$root.isTouch) ? _c('nav', {
    staticClass: "c-header__menu-burger u-relative u-click-area-xxs u-cursor-pointer",
    class: [_vm.menuMobileIsOpen ? 'is-open' : 'is-close'],
    on: {
      "click": function($event) {
        _vm._onClickOnMenuBurger()
      }
    }
  }, [_c('div', {
    staticClass: "c-header__menu-burger__bar c-header__menu-burger__bar--top u-absolute u-fit-w u-bg--brand-gold"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-header__menu-burger__bar c-header__menu-burger__bar--middle u-absolute u-fit-w u-bg--brand-gold"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-header__menu-burger__bar c-header__menu-burger__bar--bottom u-absolute u-fit-w u-bg--brand-gold"
  })]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-header__link__bars u-marg-l-xxs u-flex u-flex-jc--space-between"
  }, [_c('div', {
    staticClass: "c-header__link__bars__bar c-header__link__bars__bar--left u-fit-h u-bg--brand-gold"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-header__link__bars__bar c-header__link__bars__bar--center u-fit-h u-bg--brand-gold"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-header__link__bars__bar c-header__link__bars__bar--right u-fit-h u-bg--brand-gold"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-794eabeb"}!./src/scripts/components/app-header/template.html
// module id = 199
// module chunks = 0